import _ from 'underscore'
import Vue from 'vue'
import MicroNote from '../../resources/microNote'
import moment from 'moment'

// This is an object where microNotes will be stored
// with keys as the id, and chapter as the value
const state = {}

const getters = {
  allMicroNotes(state) {
    return _.values(state);
  },

  // Only ones that are due for studying
  unstudiedMicroNotes(state, getters) {
    let microNotes = getters.allMicroNotes;
    if( !microNotes) return [];

    // Limit microNotes to only ones that need to be studied
    const now = moment();
    microNotes = _.filter(microNotes, (microNote) => {
      if (microNote.active === false) return false;
      if( !microNote.next_study_at) return true;
      const inThePast = now.diff(microNote.next_study_at) >= 0;
      if(inThePast) return true;
    })
    return microNotes;
  },
  activeMicroNotes(state, getters) {
    let microNotes = getters.allMicroNotes;
    if (!microNotes) return [];

    // Limit microNotes to only ones that are active
    microNotes = _.filter(microNotes, (microNote) => {
      return microNote.active !== false;
    })
    return microNotes;
  },
}

const actions = {

  createMicroNote(context, payload) {
    // console.log('createMicroNote')
    // console.log(payload)
    payload.microNote.active = true;
    MicroNote.save({ micro_note: payload.microNote }).then((res) => {
      context.commit(`CREATE_MICRO_NOTE_SUCCESS`, {microNote: res.data});
      if(_.isFunction(payload.callback)) payload.callback(null, res.data);
    }, (res) => {
      Toast.error(res.error)
      if(_.isFunction(payload.callback)) payload.callback(new Error(res.error));
    })
  },


  // Retrieve all micro notes
  getMicroNotes(context) {
    console.log('Fetching micro notes...')
    MicroNote.query({}).then((res) => {
      context.commit(`RETRIEVE_MICRO_NOTES_SUCCESS`, {microNotes: res.data})
    }, (res) => {
      Toast.error('Failed to retrieve micro notes')
    })
  },

  // payload.id, payload.changes
  updateMicroNote(context, payload) {
    if( !payload.changes) throw new Error('updateMicroNote error: Missing payload.changes');

    // To delete keywords, we need to pass a blank string instead of an empty object
    if(_.has(payload.changes, 'keywords') && _.isEmpty(payload.changes.keywords)) {
      payload.changes.keywords = "";
    }

    MicroNote.update({id: payload.id}, {micro_note: payload.changes}).then((res) => {
      context.commit(`UPDATE_MICRO_NOTE_SUCCESS`, {microNote: res.data});
      if(_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to save microNote')
      if(_.isFunction(payload.callback)) payload.callback(new Error('Failed to save'));
    })
  },

  
  deleteMicroNote(context, payload) {
    MicroNote.delete({ id: payload.micronote.id }).then((res) => {
      console.log('deleted ' + payload.micronote.id)
      context.commit(`DELETE_MICRO_NOTE_SUCCESS`, { micronote: payload.micronote });
      if (_.isFunction(payload.callback)) payload.callback();
    }, (res) => {
      Toast.error('Failed to delete microNote');
      if (_.isFunction(payload.callback)) payload.callback(new Error('Failed to delete'));
    })
  },

}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    for(let prop in state) Vue.delete(state, prop)
  },


  CREATE_MICRO_NOTE_SUCCESS(state, payload) {
    // console.log(`#todo - CREATE_MICRO_NOTE_SUCCESS`)
    const microNote = payload.microNote;
    Vue.set(state, microNote.id, microNote);
  },


  RETRIEVE_MICRO_NOTES_SUCCESS(state, payload) {
    // #todo - We may want to completely clear the state at this point
    // console.log(payload.microNotes)
    _.each(payload.microNotes, (microNote) => {

      Vue.set(state, microNote.id, microNote);
    })
  },

  DELETE_MICRO_NOTE_SUCCESS(state, payload) {
    Vue.delete(state, payload.micronote.id);
  },

  // payload.microNote
  UPDATE_MICRO_NOTE_SUCCESS(state, payload) {
    Vue.set(state, payload.microNote.id, payload.microNote);
  },

  // CREATE_CHAPTER_SUCCESS(state, payload) {
  //   Vue.set(state, payload.chapter.id, payload.chapter);
  // },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/micro-notes.js